export const IMPORT_MEAL_VOUCHER_ORDER_WIZARD_NAMESPACE =
  'meal-voucher-import-order';

export const IMPORT_MEAL_VOUCHER_ORDER_STEPS = {
  FILE_IMPORT: 'file-import',
  ACTIVATION: 'activation',
  RECAP: 'recap',
} as const;

export const MealVoucherActivationMode = {
  ASAP: 'asap',
  CUSTOM_DATE: 'custom-date',
} as const;

export type MealVoucherActivationModeType =
  (typeof MealVoucherActivationMode)[keyof typeof MealVoucherActivationMode];

export const MIN_ACTIVATION_DATE_OFFSET_DAYS = 2;

export const IMPORT_MEAL_VOUCHER_ORDER_MAX_FILE_SIZE_IN_MB = 5;

export const MEAL_VOUCHER_ORDER_IMPORT_WITH_ERRORS_CODE =
  'MEAL_VOUCHER_ORDER_IMPORT_WITH_ERRORS';
